module.exports = __webpack_public_path__ + "static/thumb-f4db151941e828891763788a127d7905.png";